import { IGameState } from '../IGameState';
import { SignInState } from '../SignInState';
import { ThunkAction } from 'redux-thunk';
import { Action } from 'typesafe-actions';
import { PlatformActions } from '../PlatformActions';
import Game from '../../../Game';
import { PlatformErrorCode } from '../../../Constants/Platform';
import { DataConflictActions } from '../DataConflictActions';

/**
 * Trigger sign in on platform.
 */
export function signIn(
    silently: boolean = false
): ThunkAction<Promise<void>, IGameState, never, Action> {
    return async dispatch => {
        dispatch(PlatformActions.setSignInState(SignInState.InProgress));
        try {
            const result = await Game.sdk.driver.signIn(silently);
            if (!result.success) {
                dispatch(PlatformActions.signInFail(result.errorCode));
                return;
            }
            dispatch(PlatformActions.signInSuccess());
            // Fetch for data conflicts after signing in
            dispatch(DataConflictActions.fetchConflicts());
        } catch (e) {
            dispatch(PlatformActions.signInFail());
        }
    };
}

/**
 * Trigger sign out of platform.
 */
export function signOut(): ThunkAction<
    Promise<void>,
    IGameState,
    never,
    Action
> {
    return async dispatch => {
        dispatch(PlatformActions.setSignInState(SignInState.InProgress));
        try {
            await Game.sdk.driver.signOut();
            dispatch(PlatformActions.setSignInState(SignInState.SignedOut));
        } catch (e) {
            dispatch(PlatformActions.setSignInState(SignInState.SignedIn));
        }
    };
}

export interface IAuthReturnValues {
    success: boolean;
    errorCode: PlatformErrorCode;
}
